// API Configuration for different environments
const isDevelopment = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';

export const API_CONFIG = {
  BASE_URL: isDevelopment 
    ? 'http://localhost:5000/api'  // Development
    : 'https://purchase-request-management-system1-production.up.railway.app/api', // Production - hardcoded for testing
};

export default API_CONFIG; 